import React, { FC, useEffect, useState } from 'react'

import type { SectionsPriceAndColor } from '@/components/pages/production/components/context/types'

import SimpleMap, { SimpleMapProps } from './components/simple-map'
import SvgPanZoom from './components/svg-pan-zoom'
import styles from './styles.module.scss'

interface StyleSection {
    [property: string]: string
}

interface SectionStatus {
    style?: StyleSection
    items: Array<string>
}

interface SectionsStatus {
    selected: SectionStatus
    [anyOtherStatus: string]: SectionStatus
}

export interface MapProps extends SimpleMapProps, Record<string, unknown> {
    availablesWithColor?: SectionsPriceAndColor
    sectionsStatus?: SectionsStatus
    specificity?: string
    withPanAndZoom?: boolean
}

const StyledMap: FC<MapProps> = ({
    sectionsStatus = {},
    withPanAndZoom = false,
    specificity = 'original-map',
    availablesWithColor,
    ...mapProps
}) => {
    const [isComponentMounted, setIsComponentMounted] = useState(false)
    let map = <>Loading...</>
    const displayingFooter = 'displayFooter' in mapProps && mapProps.displayFooter === true

    useEffect(() => setIsComponentMounted(true), [])

    if (isComponentMounted) {
        map = withPanAndZoom ? (
            <SvgPanZoom
                {...mapProps}
                className={`${styles.map} ${styles.absolute}${
                    displayingFooter ? ` ${styles.withFooter}` : ''
                } ${specificity}`}
            />
        ) : (
            <SimpleMap
                {...mapProps}
                className={`${styles.map}${displayingFooter ? ` ${styles.withFooter}` : ''} ${specificity}`}
            />
        )
    }

    return (
        <>
            {!!availablesWithColor && (
                <>
                    {Object.entries(availablesWithColor).map(([sectionId, properties]) => {
                        const { color } = properties

                        return (
                            <style key={`available-${sectionId}`}>
                                {`.${specificity} path[data-svg-section-id="${sectionId}"] { fill:${color}; }\n`}
                            </style>
                        )
                    })}
                </>
            )}
            {Object.entries(sectionsStatus).map(([status, statusProperties]) => {
                const { items, style = {} } = statusProperties

                if (!items.length) return null

                const selector = items
                    .map((id: string) => `.${specificity} path[data-svg-section-id="${id}"]`)
                    .join(', ')

                return (
                    <style key={status}>{`${selector} { ${Object.entries(style)
                        .map(([property, value]) => `${property}:${value};`)
                        .join('\n')}}`}</style>
                )
            })}
            {mapProps.jsonMap && map}
        </>
    )
}

export default StyledMap
